var map = {
	"./follow_a.png": "RhI4",
	"./follow_b.png": "X49U"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tMPS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/follow_.*\.png$
// module id = tMPS
// module chunks = 12